<template>
  <div class="task-view">
    <task-header title="任务" backRouter="navigation"></task-header>
    <task-search @searchTask="searchTask" :value="inputValue"></task-search>

    <div class="task-content">
      <ul class="task-type-list flex-container">
        <li class="task-type-item flex-container" v-for="(taskTypeItem, taskTypeIndex) in taskTypeList" @click="changeStatus(taskTypeIndex)">
          <span class="icon"></span>
          <div :class="{'bold': taskTypeIndex===curStatusIndex}">
            <span class="title">{{ taskTypeItem.title }}</span>
            <span class="value">{{ taskTypeItem.total }}</span>
          </div>
        </li>
      </ul>

      <div class="task-detail">
        <div class="title flex-container"><span class="icon"></span>任务详情</div>
        <div class="task-detail-list">
          <ul class="list-thead flex-container">
            <li class="list-thead-th flex-item" v-for="item in theadList">
              <span>{{ item.name }}</span>
            </li>
          </ul>
          <!-- <div class="scroll-wrapper">
          <mt-loadmore :bottom-method="loadBottom" bottomDistance="0" ref="loadmore">
            <ul>
              <li v-for="item in 50">{{ item }}</li>
            </ul>
          </mt-loadmore>
          </div> -->
          <div class="scroll-wrapper" ref="scrollWrapper">
            <ul class="list-tbody" ref="listTbody">
              <li class="list-tr flex-container" v-for="item in taskDetailList" @click="toTaskDetail(item.taskId)">
                  <span class="list-td flex-item">{{ item.taskName }}</span>
                  <span class="list-td flex-item">{{ id===1?item.lowerName:item.executorName }}</span>
                  <span class="list-td flex-item">{{ dealTime(item.createTime) }}</span>
                  <span class="list-td flex-item">{{ dealTime(item.feedbackTime) }}</span>
                  <span class="list-td flex-item">{{ item.checkStatus == 0 ? '未开始' : item.checkStatus == 1 ? '未反馈' : item.checkStatus == 2 ? '待审核' : item.checkStatus == 3 ? '已完成' : '已退回' }}</span>
              </li>
            </ul>
            <div class="pullup-wrapper">
              <!-- <div v-if="!isPullUpLoad" class="before-trigger">
                <span class="pullup-txt">Pull up and load more</span>
              </div> -->
              <div v-if="isPullUpLoad" class="after-trigger">
                <span class="pullup-txt">Loading...</span>
              </div>
              <div v-if="taskDetailList.length === 0" class="after-trigger">
                <span class="pullup-txt">暂无数据</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TaskHeader from '@/components/base/TaskHeader'
  import TaskSearch from '@/components/base/search'
  import BScroll from '@better-scroll/core'
  import request from '@/common/js/request'
  import axios from 'axios'
  import Pullup from '@better-scroll/pull-up'
  import eventBus from '@/common/js/eventBus.js'

  BScroll.use(Pullup)

  export default {
    name: 'Task',
    data() {
      return {
        id: Number(this.$route.query.id),
        listUrl: '',
        curStatusIndex: 0,
        taskTypeList: [
          {
            id: 0,
            title: '待开始',
            checkStatus: [0, 1] // 包含未开始和未反馈
          },
          {
            id: 1,
            title: '进行中',
            checkStatus: [2, 4] // 包含待审核和已退回
          },
          {
            id: 2,
            title: '已完成',
            checkStatus: [3]
          }
        ],
        theadList: [
          {
            name: '任务名称'
          },
          {
            name: Number(this.$route.query.id)===1?'下发人':'执行人'
          },
          {
            name: '任务时间'
          },
          {
            name: '完成时间'
          },
          {
            name: '任务状态'
          }
        ],
        taskDetailList: [],
        bscroll: null,
        isPullUpLoad: false,
        inputValue: '',
        scrollWrapperHeight: 0
      }
    },
    watch: {
      taskDetailList() {
        
        setTimeout(() => {
          this.refreshScroll()

          this.setSWHeight()
        }, 0);
      },
      // $route(to, from) {
      //   let operated = to.query.operated
      //   if (operated) {
      //     this.init()
      //   }
      // }
    },
    components: {
      TaskHeader,
      TaskSearch
    },
    created() {
      eventBus.$on('operate', () => { // 在详情页操作了任务之后需重新加载数据
        this.init()
      })

      this.$nextTick(() => {
        this.scrollWrapperHeight = this.$refs.scrollWrapper.clientHeight
        this.bscroll = new BScroll('.scroll-wrapper', {
          scrollY: true,
          click: true,
          pullUpLoad: true
        })
        
        this.bscroll.on('pullingUp', this.pullingUpHandler)
      })

      this.init()

    },
    methods: {
      async pullingUpHandler() {
        // 如果数据加载完，则不再重复执行上拉加载
        if (this.taskDetailList.length === this.taskTypeList[this.curStatusIndex].total) {
          // return之后导致上拉加载功能被关闭，需手动打开
          return
        }
        this.isPullUpLoad = true

        await this.requestData()

        this.bscroll.finishPullUp()
        this.refreshScroll()
        this.isPullUpLoad = false
      },
      requestData() {
        let item = this.taskTypeList[this.curStatusIndex]
        let getListFn = this.setAxiosFn(item)

        this.singleTypeRequest(item, getListFn).then((list) => {
          item.list.push(...list)
          this.taskDetailList = this.taskTypeList[this.curStatusIndex].list
        })
      },
      // async requestData() {
      //   try {
      //     const newData = await this.axiosPost(/* url */)
      //     this.taskDetailList = this.taskTypeList[this.curStatusIndex].list
      //     console.log(this.taskDetailList)
      //   } catch (err) {
      //     // handle err
      //     console.log(err)
      //   }
      // },
      // axiosPost(/* url */) {
      //   return new Promise(resolve => {
      //       let item = this.taskTypeList[this.curStatusIndex]
      //       let checkStatus = item.checkStatus
      //       let getListFn = this.setAxiosFn(item)
      //       let axiosAllParams = getListFn.map(fn => {
      //         return fn()
      //       })
      //       if (checkStatus.length > 1) {
      //         axios.all(axiosAllParams)
      //         .then(axios.spread((res1, res2) => {
      //           console.log(11)

      //           // 两个请求现在都执行完成
      //           let data1 = res1.data.result
      //           let data2 = res2.data.result
      //           let list = data1.list.concat(data2.list)
      //           // let total = Number(data1.total) + Number(data2.total)
      //           // item.total = total
      //           console.log(item.list)
      //           item.list.push(...list)

      //           resolve(list)

      //         }));
      //       } else {
      //         axiosAllParams[0].then(res => {
      //           console.log(22)

      //           let data = res.data.result
      //           let list = data.list
      //           let total = Number(data.total)
      //           item.total = total
      //           item.list = list  
      //           resolve(list)  
      //         })
      //       }
      //   })
      // },
      init() {
        this.setRequestUrl()

        this.taskTypeList.forEach((item, index) => {
          let checkStatus = item.checkStatus
          let getListFn = this.setAxiosFn(item, true)
          let axiosAllParams = getListFn.map(fn => {
            return fn()
          })
          if (checkStatus.length > 1) {
            axios.all(axiosAllParams)
            .then(axios.spread((res1, res2) => {
              // 两个请求现在都执行完成
              let data1 = res1.data.result
              let data2 = res2.data.result
              let list = data1.list.concat(data2.list)
              let total = Number(data1.total) + Number(data2.total)
              item.total = total
              item.list =  list

              this.$set(this.taskTypeList, this.curStatusIndex, this.taskTypeList[this.curStatusIndex])
              if (this.taskTypeList[index].id === this.curStatusIndex) {
                this.taskDetailList = this.taskTypeList[this.curStatusIndex].list

                console.log(this.taskDetailList)
              }
            }));
          } else {
            axiosAllParams[0].then(res => {
              let data = res.data.result
              let list = data.list
              let total = Number(data.total)
              item.total = total
              item.list = list    
              this.$set(this.taskTypeList, this.curStatusIndex, this.taskTypeList[this.curStatusIndex])
            })
          }
          
        })
      },
      setRequestUrl() {
        let undertakeUrl = '/dpew/taskRelease/getUndertakeTaskReleaseList.action'
        let assignUrl = '/dpew/taskRelease/getTaskReleaseList.action'
        this.listUrl = this.id === 1 ? undertakeUrl : assignUrl
      },
      setAxiosFn(item, isInit) {
        // 初始化
        if (isInit) {
          item.pageNo = 1
        } else {
          item.pageNo = ++item.pageNo
        }
        let getListFn = item.checkStatus.map(value => {
          let requestParams = {
            checkStatus: value
          }
          // 初始化时不需要传入pageNo，默认是1
          if (!isInit) {
            requestParams.pageNo = item.pageNo
          }
          // 已完成只有一个状态，一次请求20条数据
          if (item.id === 2) {
            requestParams.pageSize = 20
          }
          // 当前是搜索
          if (this.inputValue) {
            requestParams.taskName = this.inputValue
          }
          let _this = this
          return function() {
            return _this.SetAxios({
              url: _this.listUrl,
              // method: 'post',
              params: requestParams
            })
          }
        })
        return getListFn
      },
      singleTypeRequest(item, getListFn) {
        return new Promise(resolve => {
          let axiosAllParams = getListFn.map(fn => {
            return fn()
          })

          if (item.checkStatus.length > 1) {
            axios.all(axiosAllParams)
            .then(axios.spread((res1, res2) => {
              // 两个请求现在都执行完成
              let data1 = res1.data.result
              let data2 = res2.data.result
              let list = data1.list.concat(data2.list)
              // item.list.push(...list)
              let total = Number(data1.total) + Number(data2.total)
              item.total = total
              // item.list = list
  
              // this.taskDetailList = list
              resolve(list)
            }));
          } else {
            axiosAllParams[0].then(res => {
              let data = res.data.result
              let list = data.list
              let total = Number(data.total)
              item.total = total
              // item.list = list   
              resolve(list) 
            })
          }
        })
        
      },
      searchTask(taskName) {
        this.inputValue = taskName
        
        let item = this.taskTypeList[this.curStatusIndex]
        // 搜索是请求的是第一页的数据，isInit为true
        let getListFn = this.setAxiosFn(item, true)
        this.singleTypeRequest(item, getListFn).then((list) => {
          item.list = list
          this.taskDetailList = this.taskTypeList[this.curStatusIndex].list
        })
      },
      refreshScroll() {
        this.bscroll && this.bscroll.refresh()
      },
      changeStatus(index) {
        // 当 状态1的数据加载完时，切换其他t状态，上拉加载无效 ，better-scroll的pullingup事件在数据全部加载完时被解绑了，因此切换tab时无效
        this.bscroll.openPullUp(true)

        this.inputValue = ''
        this.curStatusIndex = index

        // TODO当搜索之后再进行切换需重新请求，如果没有搜索过，不需要请求
        let item = this.taskTypeList[this.curStatusIndex]
        // 切换状态是请求的是第一页的数据，isInit为true
        let getListFn = this.setAxiosFn(item, true)
        this.singleTypeRequest(item, getListFn).then((list) => {
          item.list = list
          this.taskDetailList = this.taskTypeList[this.curStatusIndex].list
        })
      },
      toTaskDetail(taskId) {
        this.$router.push({
          path: '/taskDetail',
          query: {
            id: this.id,
            taskId
          }
        })
      },
      setSWHeight() { // 设置scroll-wrapper的高度，当首页加载的数据不够一屏时，下来刷新触发不了
        let scrollWrapperRef = this.$refs.scrollWrapper
        let scrollWrapperHeight = scrollWrapperRef.clientHeight
        let listTbodyHeight = this.$refs.listTbody.clientHeight
        let curTaskTotal = this.taskTypeList[this.curStatusIndex].total

        if ((this.taskDetailList.length < curTaskTotal) && (listTbodyHeight < scrollWrapperHeight)) {
          scrollWrapperRef.style.height = `${listTbodyHeight - 10}px`
        } else {
          scrollWrapperRef.style.height = `${this.scrollWrapperHeight}px`
        }
        this.refreshScroll()
      }
    },
    beforeRouteLeave (to, from, next) {
      // navigation->task，页面重新加载，taskdetail->task，保留访问记录
      if (to.name === 'Navigation') {
        let keepAlives = this.$store.state.keepAlives

        if (keepAlives.indexOf(from.name) !== -1) {
          keepAlives.splice(keepAlives.indexOf(from.name), 1)
          this.$store.commit('changeState', {
            key: 'keepAlives',
            value: keepAlives
          })
        }
      }
      next()
    }
  }
</script>

<style lang="scss" scoped>
  .task-content {
    height: calc(100% - 44px - 42px);
    background: #fff;
    .task-type-list {
      padding: 24px 24px 24px 30px;
      -webkit-justify-content: space-between;
      justify-content: space-between;
      .task-type-item {
        -webkit-align-items: center;
        align-items: center;
        .icon {
          display: inline-block;
          width: 40px;
          height: 41px;
          background-size: 100%;
        }
        .bold {
          font-weight: bold;
        }
        &:nth-child(1) {
          .icon {
            @include bg-image('~@/common/images/icon_to-start');
          }
        }
        &:nth-child(2) {
          .icon {
            @include bg-image('~@/common/images/icon_doing');
          }
        }
        &:nth-child(3) {
          .icon {
            @include bg-image('~@/common/images/icon_done');
          }
        }
        & > div {
          display: inline-block;
          font-size: 12px;
          margin-left: 8px;
          .title {
            display: inline-block;
            width: 100%;
            color: #999;
            margin-bottom: 6px;
          }
          .value {
            color: #3D6FDD;
            // font-weight: bold;
          }
        }
      }
    }
    .task-detail {
      height: calc(100% - 89px);
      padding: 0 15px;
      .title {
        border-top: 0.5px dashed #DCDCDC;
        padding: 19px 0 17px;
        // font-size: 16px;
        color: #5B667B;
        -webkit-align-items: center;
        align-items: center;
        .icon {
          display: inline-block;
          width: 19px;
          height: 17px;
          @include bg-image('~@/common/images/icon_detail');
          background-size: 100%;
          margin-right: 6px;
        }
      }
      .task-detail-list {
        height: calc(100% - 54px);
        font-size: 12px;
        text-align: center;
        .list-thead {
          height: 42px;
          background: rgba(#D1DFFF, .3);
          color: #3D6FDD;
          padding-top: 18px;
        }
        .scroll-wrapper {
          max-height: calc(100% - 42px);
        }
        .list-tbody {
          color: #969696;
          padding-bottom: 10px;
          .list-tr {
            height: 34px;
            -webkit-align-items: center;
            align-items: center;
            &:nth-child(even) {
              background: #FAFBFC;
            }
            .list-td {
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              /*! autoprefixer: off */
              -webkit-box-orient:vertical;
              /* autoprefixer: on */
              -webkit-line-clamp:2;
              line-height: 16px;
              word-break: break-all;
            }
          }
        }
        .pullup-wrapper {
          padding: 20px;
          text-align: center;
          color: #999;
        }
      }
    }
  }
</style>